/* eslint-disable react/no-danger */
/* eslint-disable max-lines */
import { Config } from '@cian/config';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { Spinner } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { readAllOffersForSavedSearches } from '../../../api/saved_searches/readAllOffers';
import { AlfaSecondaryMortgagePromo } from '../../../components/AlfaSecondaryMortgagePromo';
import { ChatPopupContainer } from '../../../containers/ChatPopupContainer';
import { FavoritesFoldersContainer } from '../../../containers/FavoritesFoldersContainer';
import { FiltersContainer } from '../../../containers/FiltersContainer';
import { HeaderSectionContainer } from '../../../containers/HeaderSectionContainer';
import { NewbuildingBrokerBannerContainer } from '../../../containers/NewbuildingBrokerBannerContainer';
import { NewbuildingPromoBuilderOffersContainer } from '../../../containers/NewbuildingPromoBuilderOffersContainer';
import { LazyNewbuildingPromoCarouselContainer } from '../../../containers/NewbuildingPromoCarousel';
import { NotAvailablePopupContainer } from '../../../containers/NotAvailablePopupContainer';
import { PaginationContainer } from '../../../containers/PaginationContainer';
import { ProfessionalSearchPromoContainer } from '../../../containers/ProfessionalSearchPromoContainer';
import { SeoMarkedListContainer } from '../../../containers/SeoMarkedListContainer';
import { SpecialProjectBannerContainer } from '../../../containers/SpecialProjectBannerContainer';
import { UndergroundMapModalContainer } from '../../../containers/UndergroundMapContainer';
import { VillagesRecommendationsContainer } from '../../../containers/VillagesRecommendationsContainer';
import { DirectionsContainer } from '../../../filters/components/directions/modal/container';
import { DistrictsContainer } from '../../../filters/components/districts/container';
import LocationSwitherContainer from '../../../filters/components/location_switcher/container';
import { MapContainer } from '../../../filters/components/map/container';
import { TTag } from '../../../filters/state/tags';
import { IJsonQuery } from '../../../json_query';
import { IOffer } from '../../../offer/types';
import { Collections } from '../../../serp/components/Collections/Collections';
import { SeoTopBanners } from '../../../serp/components/adfox/seo_top_banners';
import { AdFoxBannerType } from '../../../serp/components/adfox/templates';
import { RealtorRequestTrapContainer } from '../../../serp/components/demand';
import { FastLinksContainer } from '../../../serp/components/fast_links/container';
import { HideOfferTopPopup } from '../../../serp/components/hide_offer_top_popup';
import { NewobjectsContainer } from '../../../serp/components/newobjects/container';
import { NewobjectsFromDeveloperContainer } from '../../../serp/components/newobjects_from_developer/container';
import { OffersContainer } from '../../../serp/components/offers/container';
import { PromoteMobile } from '../../../serp/components/promote_mobile';
import { SuggestionsContainer } from '../../../serp/components/suggestions/container';
import { ComparisonNotificationContainerLoadable } from '../../../serp/containers/ComparisonNotificationContainer';
import { EmptyPageSummaryContainer } from '../../../serp/containers/EmptyPageSummaryContainer';
import { QuickLinksContainer } from '../../../serp/containers/QuickLinksContainer';
import { SeoBotCatcherLinksContainer } from '../../../serp/containers/SeoBotCatcherLinksContainer';
import { SeoCrossLinksContainer } from '../../../serp/containers/SeoCrossLinksContainer';
import { SuburbanCatalogsContainer } from '../../../serp/containers/SuburbanCatalogsContainer';
import { EHideOfferState } from '../../../serp/state/hide_offer';
import { IComparisonNotification } from '../../../serp/state/offersComparison';
import { ILocation, TLocation } from '../../../types/location';
import { IQuickLinks } from '../../../types/quickLinks';
import { TSuburbanCatalog } from '../../../types/suburbanCatalog';
import { TUser } from '../../../types/user';
import { isArrayWithItems } from '../../../utils';
import { parseHash } from '../../../utils/hash';
import { logComponentError } from '../../../utils/log_component_error';
import { IMakeRequest } from '../../../utils/request';
import { saveJsonQueryInLocalStorage } from '../../../utils/save_json_query';
import { shouldSendAdsEvent } from '../../../utils/shouldSendAdsEvent';
import { ISeoState, TDeviceType } from '../../state';
import { BannerContainer } from '../Banner';
import { ChatsContainerLoadable } from '../ChatsContainer';
import { NewbuildingConsultantPopupContainer } from '../NewbuildingConsultantPopup';
import { PreInfiniteBanner } from '../PreInfiniteBanner';
import { EPreInfiniteBannerTypes } from '../PreInfiniteBanner/PreInfiniteBanner';

const style = require('./index.css');

const FLOCTORY_CHECK_TIMEOUT = 1500;

export interface IContext {
  logger: ILogger;
}

export interface ISearchEngineResultsPageProps {
  currency: string;
  context: IContext;
  deviceType: TDeviceType;
  baseUrl: string;
  isFetching: boolean;
  isPromotionMobileClosed: boolean;
  isPrintEnabled: boolean;
  isSpecialProjectAdfoxBannerVisible: boolean;
  isNewbuildingPromoBuilderOffersVisible: boolean;
  isNewbuildingBrokerBannerVisible: boolean;
  isAlfaSecondaryMortgagePromoVisible: boolean;
  seo: ISeoState;
  subdomain: string;
  offers: IOffer[];
  quickLinks: IQuickLinks | null;
  aggregatedOffers: number;

  regions: ILocation[];
  currentLocation: TLocation;
  jsonQuery: IJsonQuery;
  tags: TTag[];

  user: TUser;
  isAdvancedModalVisible: boolean;
  isDirectionsModalVisible: boolean;
  isDistrictModalVisible: boolean;
  isLocationSwitcherVisible: boolean;
  isMapModalVisible: boolean;
  isStalkerBannerShown: boolean;
  isMetroModalVisible: boolean;
  isOfficeCalculatorVisible: boolean;
  isSignInTriggerModalOpen: boolean;
  isFilterByFlatsEnabled: boolean;
  seoTgbType: AdFoxBannerType;
  showTrap: boolean;
  makeRequest: IMakeRequest;
  isTopPopupOpened: boolean;
  hideOfferState: EHideOfferState;
  hideOfferErrorMessage: string;
  lkUrl: string;

  httpApi: IHttpApi;
  queryString: string;

  showPreInfinteSaveSearchBanner?: boolean;

  currentUrl: string | undefined;
  isOfferInSavedSearch?: boolean;
  isPromoCollectionsEnabled: boolean;
  config: Config;

  comparisonNotification: IComparisonNotification | null;
  additionalPuids: { [key: string]: string };
  suburbanCatalogsTypes: TSuburbanCatalog[];
}

export interface ISearchEngineResultsPageDispatchProps {
  setKeyPushNotificationValue(value: boolean): void;

  setHideOfferState(hideOfferState: EHideOfferState): void;

  setLoading(): void;
}

export interface ISearchEngineResultsState {
  isMounted: boolean;
}

export type TSearchEngineResultsPageProps = ISearchEngineResultsPageProps & ISearchEngineResultsPageDispatchProps;

export class SearchEngineResultsPage extends React.Component<TSearchEngineResultsPageProps, ISearchEngineResultsState> {
  public context: IContext;
  public state = {
    isMounted: false,
  };

  /* istanbul ignore next */
  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logComponentError({
      error,
      errorInfo,
      logger: this.props.context.logger,
    });
  }

  /* istanbul ignore next */
  public componentDidMount() {
    const { setKeyPushNotificationValue, setHideOfferState, httpApi, context, queryString, jsonQuery } = this.props;

    saveJsonQueryInLocalStorage(jsonQuery);

    const checkFlocktoryLoad: Promise<IFlocktory> = new Promise(resolve => {
      const flocktoryAttempt = () => {
        if (window.flocktory && typeof window.flocktory.getSubscriptionStatus === 'function') {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          clearTimeout(timeIntervalFlocktoryCheck);

          return resolve(window.flocktory);
        }

        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        timeIntervalFlocktoryCheck = setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
      };

      let timeIntervalFlocktoryCheck = setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
    });

    checkFlocktoryLoad.then(flocktory => {
      flocktory.getSubscriptionStatus().then(response => {
        /**
         * Если flocktory вернули поле subscribed и оно равно false,
         * значит текущий пользователь не подписан на пуши.
         */
        if ('subscribed' in response && !response.subscribed) {
          setKeyPushNotificationValue(true);
        }
      });
    });

    /**
     * При уходе с выдачи по сохраненному поиску отметить все "новые" оферы просмотренными
     */
    window.addEventListener('beforeunload', () => {
      const searchParams = new URLSearchParams(queryString);
      if (searchParams.has('saved_search_id')) {
        const savedSearchId = Number(searchParams.get('saved_search_id'));
        readAllOffersForSavedSearches(httpApi, { savedSearchId }, context.logger);
      }
    });

    /* istanbul ignore next */
    window.addEventListener('popstate', async () => {
      this.props.setLoading();
      window.location.reload();
    });

    const parsedHash = parseHash(window.location.hash);
    if (Object.keys(parsedHash).includes('HIDE')) {
      setHideOfferState(parsedHash['HIDE'] as EHideOfferState);
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }

    this.setState({ isMounted: true });
  }

  /* istanbul ignore next */
  public componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  /* istanbul ignore next */
  public render() {
    const {
      baseUrl,
      deviceType,
      isFetching,
      isPrintEnabled,
      isPromotionMobileClosed,
      offers,
      quickLinks,
      seo,
      makeRequest,
      isTopPopupOpened,
      hideOfferState,
      hideOfferErrorMessage,
      showTrap,
      isOfferInSavedSearch,
      isPromoCollectionsEnabled,
      isFilterByFlatsEnabled,
      comparisonNotification,
      additionalPuids,
      seoTgbType,
      isSpecialProjectAdfoxBannerVisible,
      isNewbuildingBrokerBannerVisible,
      isNewbuildingPromoBuilderOffersVisible,
      isAlfaSecondaryMortgagePromoVisible,
      suburbanCatalogsTypes,
    } = this.props;

    const isQuickLinksAvailable =
      quickLinks &&
      isArrayWithItems(quickLinks.links) &&
      quickLinks.links.some(({ offersCount }) => Boolean(offersCount));

    return (
      <div className={classNames(style['serp'], style['serp--light'])}>
        {seo.text && <div className={style['seoText']} dangerouslySetInnerHTML={{ __html: seo.text }} />}
        <SeoMarkedListContainer />
        <ErrorLogComponent logger={this.props.context.logger}>
          <FiltersContainer />
        </ErrorLogComponent>
        {isFetching && (
          <div className={style['preloadOverlay']}>
            <div className={style['preloader']}>
              <Spinner size={50} />
            </div>
          </div>
        )}
        {!isSpecialProjectAdfoxBannerVisible && !isNewbuildingPromoBuilderOffersVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <BannerContainer />
          </ErrorLogComponent>
        )}
        <ErrorLogComponent logger={this.props.context.logger}>
          <HeaderSectionContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <EmptyPageSummaryContainer />
        </ErrorLogComponent>

        {deviceType !== 'desktop' && !isPromotionMobileClosed && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <PromoteMobile />
          </ErrorLogComponent>
        )}
        {isQuickLinksAvailable && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <QuickLinksContainer
              banner={
                suburbanCatalogsTypes.length <= 1 ? (
                  <SuburbanCatalogsContainer catalogsTypes={suburbanCatalogsTypes} />
                ) : undefined
              }
            />
          </ErrorLogComponent>
        )}
        {(!isQuickLinksAvailable || suburbanCatalogsTypes.length > 1) && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <SuburbanCatalogsContainer catalogsTypes={suburbanCatalogsTypes} fullWidth />
          </ErrorLogComponent>
        )}
        <ErrorLogComponent logger={this.props.context.logger}>
          {isAlfaSecondaryMortgagePromoVisible ? (
            <AlfaSecondaryMortgagePromo />
          ) : isNewbuildingPromoBuilderOffersVisible ? (
            <NewbuildingPromoBuilderOffersContainer />
          ) : isSpecialProjectAdfoxBannerVisible ? (
            <SpecialProjectBannerContainer />
          ) : isNewbuildingBrokerBannerVisible ? (
            <NewbuildingBrokerBannerContainer />
          ) : (
            <ProfessionalSearchPromoContainer />
          )}
        </ErrorLogComponent>
        {isPromoCollectionsEnabled && <Collections />}
        <ErrorLogComponent logger={this.props.context.logger}>
          <OffersContainer />
        </ErrorLogComponent>
        <ErrorLogComponent logger={this.props.context.logger}>
          <NewobjectsContainer />
        </ErrorLogComponent>
        <ErrorLogComponent logger={this.props.context.logger}>
          <NewobjectsFromDeveloperContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          {this.props.showPreInfinteSaveSearchBanner && (
            <PreInfiniteBanner
              type={EPreInfiniteBannerTypes.subscription}
              isOfferInSavedSearch={isOfferInSavedSearch}
            />
          )}
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <SuggestionsContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <PaginationContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <LazyNewbuildingPromoCarouselContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <VillagesRecommendationsContainer />
        </ErrorLogComponent>

        {showTrap && (
          <div className={style['wrapper']} data-testid="realtor_request_trap">
            <ErrorLogComponent logger={this.props.context.logger}>
              <RealtorRequestTrapContainer />
            </ErrorLogComponent>
          </div>
        )}

        <div className={style['wrapper']}>
          <ErrorLogComponent logger={this.props.context.logger}>
            <SeoCrossLinksContainer />
          </ErrorLogComponent>
        </div>

        <ErrorLogComponent logger={this.props.context.logger}>
          <FastLinksContainer />
        </ErrorLogComponent>
        {!isPrintEnabled && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <SeoTopBanners
              offers={offers}
              baseUrl={baseUrl}
              isAgent={this.props.user.isAuthenticated && this.props.user.isAgent}
              makeRequest={makeRequest}
              additionalPuids={additionalPuids}
              type={seoTgbType}
              shouldSendAdsEvent={shouldSendAdsEvent(this.props.jsonQuery) || !isFilterByFlatsEnabled}
            />
          </ErrorLogComponent>
        )}

        <ErrorLogComponent logger={this.props.context.logger}>
          <UndergroundMapModalContainer />
        </ErrorLogComponent>

        {this.props.isMapModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <MapContainer />
          </ErrorLogComponent>
        )}
        {this.props.isLocationSwitcherVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <LocationSwitherContainer />
          </ErrorLogComponent>
        )}
        {this.props.isDistrictModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <DistrictsContainer />
          </ErrorLogComponent>
        )}
        {this.props.isDirectionsModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <DirectionsContainer />
          </ErrorLogComponent>
        )}
        {this.state.isMounted && isTopPopupOpened && (
          <HideOfferTopPopup
            isError={hideOfferState === EHideOfferState.ERROR}
            lkUrl={this.props.lkUrl}
            errorMessage={hideOfferErrorMessage}
          />
        )}
        <NewbuildingConsultantPopupContainer />
        <ChatsContainerLoadable />
        {/** TODO: Возможно стоит подумать об архитектуре 3х разных чатов */}
        <ChatPopupContainer />

        <NotAvailablePopupContainer />

        <FavoritesFoldersContainer />

        <ErrorLogComponent logger={this.props.context.logger}>
          <SeoBotCatcherLinksContainer />
        </ErrorLogComponent>
        {comparisonNotification && <ComparisonNotificationContainerLoadable notification={comparisonNotification} />}
      </div>
    );
  }
}
